module.exports = __webpack_public_path__ + "static/media/package-pro.d2ab9476.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/package-pro.svg
// module id = 125
// module chunks = 0